// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1UN1x","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3TdWi"};